// extracted by mini-css-extract-plugin
export default {"table":"Skills_table__jzUez","row":"Skills_row__A8P4S","group":"Skills_group__bp4+S","items":"Skills_items__tA6ty","skill":"Skills_skill__mMQdw"};